"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ArrowUp = () => (react_1.default.createElement("svg", { width: "14", height: "8", viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M7 0.999999L7.53033 0.469669C7.23744 0.176776 6.76256 0.176776 6.46967 0.469669L7 0.999999ZM13.5303 6.46967L7.53033 0.469669L6.46967 1.53033L12.4697 7.53033L13.5303 6.46967ZM6.46967 0.469669L0.46967 6.46967L1.53033 7.53033L7.53033 1.53033L6.46967 0.469669Z", fill: "#21145A" })));
exports.default = ArrowUp;
